import BackButton from "../../../components/Buttons/BackButton";
import BasicButton from "../../../components/Buttons/BasicButton";
import XsCont from "../../../components/containers/Xs";
import HeaderSignOut from "../../../components/headers/HeaderSignOut";
import PasswordField from "../../../components/textField/PasswordField";
import { validationMessage } from "../../../consts/ValidationMessage";
import { getUserPool } from "../../../utils/cognitoUtils";
import {
  isExactPasswordFormat,
  validateRequiredFields,
  ValidationErrors,
} from "../../../utils/validationUtils";
import { Box, Typography } from "@mui/material";
import {
  CognitoUser,
  CognitoUserPool,
  CognitoUserSession,
} from "amazon-cognito-identity-js";
import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";

const PasswordChangePage: FC = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState<ValidationErrors>({});
  const navigate = useNavigate();

  const loginId: string = sessionStorage.getItem("loginId") || "";

  const handleClickShowPassword: () => void = (): void =>
    setShowPassword((prev: boolean): boolean => !prev);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate: () => boolean = (): boolean => {
    const requiredFields: string[] = [
      "currentPassword",
      "newPassword",
      "confirmPassword",
    ];
    const errorMessages = {
      currentPassword: `現在のパスワード${validationMessage.REQUIRED}`,
      newPassword: `新しいパスワード${validationMessage.REQUIRED}`,
      confirmPassword: `新しいパスワード(確認用)${validationMessage.REQUIRED}`,
    };
    const newErrors = validateRequiredFields(
      form,
      requiredFields,
      errorMessages
    );
    if (!newErrors.newPassword && !newErrors.confirmPassword) {
      if (form.newPassword.length < 10) {
        newErrors.newPassword = validationMessage.PW_LENGTH;
      }
      if (form.newPassword === loginId) {
        newErrors.newPassword = validationMessage.PW_CONFIRM_LOGINID;
      }
      if (!isExactPasswordFormat(form.newPassword)) {
        newErrors.password = validationMessage.PW_FORMAT;
      }
      if (form.newPassword !== form.confirmPassword) {
        newErrors.confirmPassword = validationMessage.PW_CONFIRM;
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClickButton: () => void = (): void => {
    if (!validate()) return;
    try {
      const userPool: CognitoUserPool = getUserPool();
      const cognitoUser: CognitoUser | null = userPool.getCurrentUser();
      if (cognitoUser) {
        cognitoUser.getSession(
          (err: Error | null, session: CognitoUserSession): void => {
            if (err || !session.isValid()) {
              alert("再ログインが必要です。");
              navigate("/signin");
              return;
            }
            cognitoUser.changePassword(
              form.currentPassword,
              form.newPassword,
              (err: Error | undefined): void => {
                if (err) {
                  navigate("/error");
                } else {
                  navigate("/pw/change/comp");
                }
              }
            );
          }
        );
      } else {
        alert("ログイン情報がありません。再ログインしてください。");
        navigate("/signin");
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      navigate("/error");
    }
  };

  const handleClickButtonCancel = () => {
    navigate("/menu");
  };

  return (
    <>
      <HeaderSignOut />
      <XsCont>
        <Box mt={10} textAlign="center">
          <Typography variant="h5" gutterBottom>
            パスワード変更
          </Typography>
        </Box>
        <Box
          component="form"
          mt={5}
          display="flex"
          flexDirection="column"
          gap={3}
        >
          <PasswordField
            label="現在のパスワード"
            name="currentPassword"
            value={form.currentPassword}
            error={!!errors.currentPassword}
            helperText={errors.currentPassword}
            onChange={handleChange}
            showPassword={showPassword}
            onTogglePasswordVisibility={handleClickShowPassword}
          />
          <PasswordField
            label="新しいパスワード"
            name="newPassword"
            value={form.newPassword}
            error={!!errors.newPassword}
            helperText={errors.newPassword}
            onChange={handleChange}
            showPassword={showPassword}
            onTogglePasswordVisibility={handleClickShowPassword}
          />
          <PasswordField
            label="新しいパスワード(確認用)"
            name="confirmPassword"
            value={form.confirmPassword}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword}
            onChange={handleChange}
            showPassword={showPassword}
            onTogglePasswordVisibility={handleClickShowPassword}
          />
          <BasicButton onClick={handleClickButton} mt={5}>
            パスワード変更
          </BasicButton>
          <BackButton onClick={handleClickButtonCancel} mt={0}>
            戻る
          </BackButton>
        </Box>
      </XsCont>
    </>
  );
};

export default PasswordChangePage;
